import React from 'react';
import { CheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-12 px-4 bg-dark-100" data-id="element-166">
      <div className="max-w-5xl mx-auto" data-id="element-167">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-168">
          La Oferta
        </p>
        <div className="text-center mb-12" data-id="element-169">
          <h2 className="text-2xl md:text-3xl font-bold text-body mb-2" data-id="element-170">
            THE RESET PROTOCOL: El Sistema de 30 Días.
          </h2>
          <p className="text-base text-gold font-serif italic" data-id="element-171">
            Lo que recibirás hoy:
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-172">
          {/* Product Mockup */}
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-173">
            <img src="https://cdn.magicpatterns.com/uploads/eUMaxiDeNTeponHVZGA7Xu/hf_20260323_013626_57688643-b6e0-4981-ab06-2be0772525cd.jpg" alt="The Reset Protocol Mockup" className="w-full max-w-md h-auto rounded-lg" data-id="element-174" />
          </div>

          {/* Offer Items */}
          <div className="w-full md:w-1/2 space-y-[8px]" data-id="element-175">
            <div className="flex items-start gap-3" data-id="element-176">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-177" />
              <div className="text-base" data-id="element-178">
                <span className="text-body font-bold" data-id="element-179">
                  PROTOCOLO DE RECALIBRACIÓN MENTAL:
                </span>{' '}
                <span className="text-sub" data-id="element-180">
                  El manifiesto de Gabriel para entender tu nueva frecuencia.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-181">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-182" />
              <div className="text-base" data-id="element-183">
                <span className="text-body font-bold" data-id="element-184">
                  HOJA DE RUTA: TU PLAN DE 30 DÍAS:
                </span>{' '}
                <span className="text-sub" data-id="element-185">
                  Tu plan paso a paso. Sin adivinanzas.
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-186">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-187" />
              <div className="text-base" data-id="element-188">
                <span className="text-body font-bold" data-id="element-189">Librería de Audios:</span>{' '}
                <span className="text-sub" data-id="element-190">
                  Frecuencias 6AM, Enfoque y Recalibración Profunda
                  (Delta/Theta).
                </span>
              </div>
            </div>

            <div className="flex items-start gap-3" data-id="element-191">
              <CheckIcon className="w-[18px] h-[18px] text-gold shrink-0 mt-0.5" data-id="element-192" />
              <div className="text-base" data-id="element-193">
                <span className="text-body font-bold" data-id="element-194">
                  Comunidad Privada en Telegram:
                </span>{' '}
                <span className="text-sub" data-id="element-195">No camines solo.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}